module.exports = __webpack_public_path__ + "img/icon-game-10624.a3e3c24c.png";